import React from 'react';

/**
 * Ornate vintage corner flourish for fine-dining menu frames.
 * Oriented for the top-left corner by default — rotate with `rotate-90` /
 * `rotate-180` / `-rotate-90` to place at the other three corners.
 * Uses `currentColor` so it inherits the `text-*` color utility.
 */
const CornerFlourish: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" {...props}>
        {/* Corner bracket */}
        <path d="M5 30 V9a4 4 0 0 1 4-4h17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        {/* Inner flourish curl */}
        <path
            d="M5 30c0-7.5 5-13 12.5-13 4.5 0 7 2.2 7 5.4 0 2.6-1.9 4.2-4.2 4.2-2 0-3.3-1.2-3.3-2.9 0-1.6 1.5-2.7 3.2-2.2"
            stroke="currentColor"
            strokeWidth="1.1"
            strokeLinecap="round"
        />
        {/* Accent dots */}
        <circle cx="9" cy="9" r="1.6" fill="currentColor" />
        <circle cx="5" cy="22" r="1" fill="currentColor" />
        <circle cx="16" cy="5" r="1" fill="currentColor" />
    </svg>
);

export default CornerFlourish;
